<template>
  <div class="myDatePickerBox">
    <el-date-picker
      class="myDatePickerStart"
      :value-format="formatType"
      v-model="myDatePicker[0]"
      @change="updateMyDate"
      :clearable="false"
      :picker-options="pickerOptions1"
      type="date"
      :format="formatType"
      size="small"
      placeholder="开始日期"
    ></el-date-picker>
    <span class="range">至</span>
    <el-date-picker
      class="myDatePickerEnd"
      v-model="myDatePicker[1]"
      type="date"
      size="small"
      :clearable="false"
      :format="formatType"
      :value-format="formatType"
      :picker-options="pickerOptions2"
      @change="clearMyDataPicker"
      placeholder="结束日期"
    ></el-date-picker>
  </div>
</template>

<script>
export default {
  name: 'myDatePicker',
  props: ['dateInit', 'format'],
  data () {
    return {
      myDatePicker: this.dateInit || ['', ''],
      formatType: this.format || 'yyyy-MM-dd',
      pickerOptions1: {
        disabledDate: time => {
          return time.getTime() > new Date().getTime()
        }
      },
      pickerOptions2: {
        disabledDate: time => {
          if (this.myDatePicker[0]) {
            return time.getTime() > new Date().getTime() || time.getTime() < new Date(this.myDatePicker[0]).getTime() - 86400000 || time.getTime() > new Date(this.myDatePicker[0]).getTime() + 30 * 86400000
          }
          return time.getTime() > new Date().getTime()
        }
      }
    }
  },
  created () {
  },
  watch: {
    dateUpdate (v) {
      this.myDatePicker = v
    }
  },
  computed: {
    dateUpdate () {
      return this.dateInit || ['', '']
    }
  },
  methods: {
    clearMyDataPicker () {
      // 清空
      if (this.myDatePicker[1] === '' || this.myDatePicker[1] === null) {
        this.myDatePicker = ['', '']
      }
      if (this.myDatePicker[0] === '' || this.myDatePicker[0] === null) {
        this.myDatePicker = [this.myDatePicker[1], this.myDatePicker[1]]
      }
      // 传值
      this.$emit('sendMyDate', this.myDatePicker)
    },
    // 更新结束日期范围
    updateMyDate () {
      if (
        new Date(this.myDatePicker[0]) >
        new Date(this.myDatePicker[1] || '1970-01-01')
      ) {
        }
    this.myDatePicker = [this.myDatePicker[0], this.myDatePicker[0]]
      // 传值
      this.$emit('sendMyDate', this.myDatePicker)
    }
  }
}
</script>

<style lang="scss">
.myDatePickerBox {
  display: inline-flex;
  border-radius: 4px 4px;
  border: 1px solid #e4e7ed;
  line-height: 29px;
  height: 32px;
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 140px !important;
  }
  .myDatePickerStart {
    width: 140px;
    height: 30px;
    input {
      text-align: center;
      border-right: none;
      border-radius: 4px 0 0 4px;
      padding-right: 0px;
      border: 0;
      height: 30px;
    }
    .el-input__prefix,
    .el-input__suffix {
      height: 30px;
    }
  }
  .myDatePickerEnd {
    width: 170px;
    height: 30px;
    input {
      text-align: center;
      border-left: none;
      border-radius: 4px;
      height: 30px;
      border: 0;
    }
    .el-input__prefix,
    .el-input__suffix {
      height: 30px;
    }
  }
  .range {
    font-size: 12px;
    display: inline-block;
    // border-top: 0.066667rem solid #dcdfe6;
    // border-bottom: 0.066667rem solid #dcdfe6;
    // margin: 6px -6px;
    margin-bottom: 0;
    color: #606266;
  }
}
</style>
